// Parse a free-text vendor payment term into net days. Accepts every shape the
// Vendor master actually stores: the seed writes 'Net 30'/'Net 45'/... verbatim
// (apps/api/prisma/seed.ts), while the schema comment documents the compact
// 'N30' form, and ad-hoc data may carry a bare '30'. All map to 30. Everything
// else (COD, blank, null, unknown) → 0. Mirrors the API's term parsing so the
// AI-booked bill's dueDate matches a manual bill (§15.1 fix).
export function parseTermsDays(terms: string | null | undefined): number {
  if (!terms) return 0;
  // Matches 'N30', 'Net 30', 'NET30', or a bare '30' (optional whitespace).
  const m = /^(?:n(?:et)?\s*)?(\d+)$/i.exec(terms.trim());
  return m ? Number(m[1]) : 0;
}
